import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { staticRoutes } from './static-routes'
import { RouterModule } from '@angular/router'
import {
  ConfigModule,
  I18nModule,
  UrlModule,
  provideConfig,
} from '@spartacus/core'
import { defaultRoutingConfig } from './default-routing.config'
import { environment } from '../../environments/environment'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    // dependend module for semantic URLs
    UrlModule,
    I18nModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['sharedComponents'],
        },
      },
    }),

    // standard non-spartacus routes
    RouterModule.forChild(staticRoutes),
  ],
  providers: [provideConfig(defaultRoutingConfig)],
})
export class RoutingModule {}
